import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "../../../../components/ui/form";
import { Input } from "../../../../components/ui/input";

interface StockAlertSectionProps {
  form: any;
}

export function StockAlertSection({ form }: StockAlertSectionProps) {
  return (
    <div>
      <div className="rounded-lg border bg-card text-card-foreground shadow-sm p-6">
        <h3 className="text-lg font-medium mb-2">Stock Alert Settings</h3>
        <p className="text-sm text-muted-foreground mb-4">Configure when you want to be notified about low stock or approaching expiration dates.</p>
        <div className="grid grid-cols-2 gap-6">
          <FormField
            control={form.control}
            name="minThreshold"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Minimum Count Threshold</FormLabel>
                <FormControl>
                  <Input type="number" {...field} onChange={(e) => field.onChange(Number(e.target.value))} />
                </FormControl>
                <p className="text-sm text-muted-foreground">
                  You'll be alerted when stock falls below this quantity
                </p>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="minExpirationThreshold"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Minimum Days to Expiration</FormLabel>
                <FormControl>
                  <Input type="number" {...field} onChange={(e) => field.onChange(Number(e.target.value))} />
                </FormControl>
                <p className="text-sm text-muted-foreground">
                  You'll be alerted when items are this many days from expiring
                </p>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>
    </div>
  );
}
